import { FC, PropsWithChildren, ReactEventHandler } from 'react';
import { Typography } from '@mui/material';

import useStyles from '@/designSystem/Form/Radio/styles';
import { Typo } from '@/designSystem/theme';

const generateRandomString = (): string =>
  Math.random().toString(36).substr(2, 9);

type Props = {
  onChange?: ReactEventHandler;
  onBlur?: ReactEventHandler;
  isChecked: boolean;
  name?: string;
  id?: string;
  typographyVariant?: Typo;
  hasHoverEffect?: boolean;
};

export const Radio: FC<PropsWithChildren<Props>> = ({
  onChange,
  onBlur,
  isChecked,
  children,
  /** TODO: useId quand on passe a React 18 */
  name = generateRandomString(),
  /** TODO: useId quand on passe a React 18 */
  id = generateRandomString(),
  typographyVariant = 'bodyMd',
  hasHoverEffect: hoverEffect = false,
}) => {
  const { classes } = useStyles({ hoverEffect });
  return (
    <div className={classes.root}>
      <label className={classes.label} htmlFor={id}>
        <input
          id={id}
          name={name}
          type="radio"
          checked={isChecked}
          onChange={onChange}
          onBlur={onBlur}
          readOnly={!!onChange}
        />
        <Typography variant={typographyVariant} component="span">
          {children}
        </Typography>
      </label>
    </div>
  );
};
